Hearsay = require 'hearsay'
pluginChangedSignal = require 'views/internal/plugins/plugins-changed-signal'
PluginBadgeView = require 'views/plugin/plugin-badge-view'
PluginRunner = require 'views/internal/plugins/plugin-runner'
PluginView = require 'views/plugin/plugin-view'
PostRender = require 'views/lib/post-render'
Promise = require 'bluebird'
trackUe = require 'debug/trackUe'
_ = require 'underscore'

globalBadgeCache = {}
lastIdBoard = null
trackedFrontBadges = {}

module.exports = class PluginCardBadgesView extends PluginView
  tagName: 'span'
  badgeView: PluginBadgeView

  runnerOptions: ->
    command: 'card-badges'
    board: @model.getBoard()
    card: @model
    timeout: 10000

  _cacheKey: ->
    { command, board, card } = @runnerOptions()
    [command, board?.id, card?.id].join(':')

  vigor: @VIGOR.NONE
  renderOnce: ->
    if (cachedBadges = globalBadgeCache[@_cacheKey()])?
      @renderResolvedBadges(cachedBadges)

    idBoard = @model.getBoard()?.id
    if idBoard && idBoard != lastIdBoard
      # when we switch boards we should clear out tracking cache
      # that way if we go back to the old board we will track it
      lastIdBoard = idBoard
      trackedFrontBadges = {}

    PostRender.enqueue "plugin_badges_render_#{ @cid }", ({ delayed }) =>
      options = @runnerOptions()

      latestPluginBadges = null

      changeSignal = Hearsay.combine pluginChangedSignal(options.board, options.card), @model.snoop()

      @subscribe changeSignal, =>
        PluginRunner.all options
        .then (pluginBadges) =>
          latestPluginBadges = pluginBadges

          resolvedBadges = []
          isCurrent = ->
            latestPluginBadges == pluginBadges
          rerender = =>
            if isCurrent()
              @renderResolvedBadges(resolvedBadges)
              # remove callbacks before caching badges; we can't trust the callbacks
              # to still be retained / available when we use the cached badges
              globalBadgeCache[@_cacheKey()] = resolvedBadges.map((b) -> _.omit(b, 'callback'))

          @cancelOnRemove Promise.map pluginBadges, (pluginBadge, index) =>
            @retain(pluginBadge)

            if pluginBadge.dynamic?
              update = =>
                updater = pluginBadge.dynamic()
                .cancellable()
                .then (badge) =>
                  resolvedBadges[index] = badge
                  rerender()

                  if badge.refresh && isCurrent()
                    refresh = Math.max(10, badge.refresh)
                    # Add some noise (+-1sec) to refresh interval to reduce clumping
                    refresh += Math.random() * 2 - 1
                    @setTimeout(update, refresh * 1000)
                .catch PluginRunner.Error.NotHandled, =>
                  null

                @cancelOnRemove(updater)
                updater

              update()
            else
              resolvedBadges[index] = pluginBadge
          .cancellable()
          .then ->
            rerender()
          .catch Promise.CancellationError, (->)
        .done()

    @

  trackBadges: (idPlugin) ->
    if !trackedFrontBadges[idPlugin]
      trackedFrontBadges[idPlugin] = true
      trackUe('board view', 'views', 'Power-Up', '', '', 'card-badges', idPlugin)

  renderResolvedBadges: (pluginBadges) ->
    subviews = pluginBadges.map (badge, index) =>
      # track badge views
      if badge?.idPlugin
        @trackBadges(badge.idPlugin)

      sv = @subview @badgeView, @model, { pluginBadge: badge }, index
      # We may be re-using a badge view, so make sure to use the latest badge values
      sv.updateBadge(badge)
      sv

    @ensureSubviews _.compact(subviews)



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-badges-view.coffee